import axios from "axios";
import { VAIPEDE_API } from "./api";

// Axios isolado para o garçom (token próprio)
export const garAxios = axios.create({ baseURL: VAIPEDE_API });
garAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("vaipede_garcom_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
garAxios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vaipede_garcom_token");
      localStorage.removeItem("vaipede_garcom");
      if (!window.location.pathname.includes("/vaipede/garcom/login")) {
        window.location.href = "/vaipede/garcom/login";
      }
    }
    return Promise.reject(err);
  }
);
